import LogRocket from 'logrocket'

export const normalizeValidationErrors = validationErrors => {
  if (validationErrors) {
    return validationErrors.reduce((acc, { field, message }) => {
      acc[field] = message
      return acc
    }, {})
  }
}

const defaultErrorMessage =
  'Oops! Something went wrong. If this continues to happen, please contact support.'

export const normalizeDeliveryErrorMessage = serverMessage => {
  switch (serverMessage) {
    case 'PAST_CUTOFF':
      return 'Sorry, you have passed the order cutoff time for this delivery'
    case 'SOLD_OUT':
      return 'Sorry, this delivery is sold out'
    case 'NOT_CANCELABLE':
      return 'This order has been processed so it cannot be cancelled'
    default:
      return defaultErrorMessage
  }
}

function parseHtmlEntities(str) {
  return str.replace(/&#([0-9]{1,3});/gi, (match, numStr) => {
    const num = parseInt(numStr, 10) // read num as normal number
    return String.fromCharCode(num)
  })
}

export const normalizeLocationErrorResponse = response => {
  const message = 'Invalid location, please enter a new address.'
  switch (response.status) {
    case 400:
      return message
    case 404:
      return message
    default:
      return defaultErrorMessage
  }
}

/**
 * A generic error handler that produces a user friendly error message.
 * All error messages can be overridden via the defaults parameter.
 * @param {*} response The error response. This must contain a `status` property.
 * @param {*} defaults An object containing overriding messages for the various error scenarios.
 */
export const normalizeErrorResponse = (response = {}, defaults = {}) => {
  let message
  if (typeof defaults === 'string') {
    message = defaults
  } else {
    const { defaultMessage } = defaults
    message = defaultMessage
  }

  switch (response.status) {
    case 404: {
      const { notFound } = defaults
      message = notFound
      return message || 'We were unable to find the item you were looking for.'
    }
    default:
      if (response && response.data) {
        // server supplied a prettier error message
        if (response.data.exceptionMessage) {
          message = response.data.exceptionMessage
        } else if (response.data.errorMessage) {
          message = response.data.errorMessage
        } else if (response.data.errorDescription) {
          message = response.data.errorDescription
        } else if (response.data.errorMessage) {
          message = response.data.errorMessage
        } else if (response.data.message) {
          message = response.data.message
        } else if (response.data.message) {
          message = response.data.message
        } else if (typeof response.data === 'string') {
          message = response.data.replace('101:', '')
        }
      }
  }
  if (message === 'Bad credentials') {
    message = 'Invalid email address or password.'
  }
  return parseHtmlEntities(message || defaultErrorMessage)
}

export const normalizeInvalidTokenError = response => {
  let message = defaultErrorMessage
  if (response.status === 401 && response.data.error === 'invalid_token') {
    message = 'Invalid Token: your token has either expired or it is invalid.'
  }
  return message
}

export const normalizeUserCreationError = response => {
  let message = defaultErrorMessage
  // server supplied a prettier error message
  if (
    response &&
    response.data &&
    response.data.validationErrors &&
    response.data.validationErrors.length &&
    response.data.validationErrors[0].message
  ) {
    message = response.data.validationErrors[0].message
  }
  if (
    /user with the username of (.*) has already been confirmed/.test(message)
  ) {
    message = 'This email address has already been used. Please login.'
  }
  if (/User with id of (.*) does not exist/.test(message)) {
    message = 'This email address does not exist.'
  }
  if (/Illegal request to friend yourself/.test(message)) {
    message = 'You cannot send yourself a friend request'
  }
  return parseHtmlEntities(message || defaultErrorMessage)
}

export const logException = ex => {
  if (process.env.REACT_APP_LOGROCKET_ID) {
    LogRocket.captureException(ex)
  } else {
    console.error(ex)
  }
}
